import AuthStore from 'components/auth/auth.store';
import IntermediaryStore from 'components/intermediary/intermediary.store';
import ApplicationsStore from 'components/applications/applications.store';
import CompanyNotificationsStore from 'components/companyNotifications/companyNotifications.store';
import IntermediaryApplicationsStore from 'components/intermediaryApplications/intermediaryApplications.store';
import UsersStore from 'components/users/users.store';
import RolesStore from 'components/roles/roles.store';
import PermissionsStore from 'components/permissions/permissions.store';
import UserEmailNotificationsStore from 'components/myProfile/UserEmailNotifications/userEmailNotifications.store';
import PrequalificationStore from 'components/prequalification/prequalification.store';
import GlobalModalsStore from 'components/MainLayout/GlobalModals/globalModals.store';

export class RootStore {
  authStore: AuthStore;

  intermediaryStore: IntermediaryStore;

  applicationsStore: ApplicationsStore;

  companyNotificationsStore: CompanyNotificationsStore;

  intermediaryApplicationsStore: IntermediaryApplicationsStore;

  usersStore: UsersStore;

  rolesStore: RolesStore;

  permissionsStore: PermissionsStore;

  userEmailNotificationsStore: UserEmailNotificationsStore;

  prequalificationStore: PrequalificationStore;

  globalModalsStore: GlobalModalsStore;

  constructor() {
    this.authStore = new AuthStore();
    this.intermediaryStore = new IntermediaryStore();
    this.applicationsStore = new ApplicationsStore();
    this.companyNotificationsStore = new CompanyNotificationsStore();
    this.intermediaryApplicationsStore = new IntermediaryApplicationsStore();
    this.usersStore = new UsersStore();
    this.rolesStore = new RolesStore();
    this.permissionsStore = new PermissionsStore();
    this.userEmailNotificationsStore = new UserEmailNotificationsStore();
    this.prequalificationStore = new PrequalificationStore();
    this.globalModalsStore = new GlobalModalsStore();
  }
}
